/*Array.prototype.remove = function() {
    var what, a = arguments, L = a.length, ax;
    while (L && this.length) {
        what = a[--L];
        while ((ax = this.indexOf(what)) !== -1) {
            this.splice(ax, 1);
        }
    }
    return this;
};*/

const { default: axios } = require("axios");

if (typeof jQuery !== "undefined") {
    jQuery.fn.isOnScreen = function (extra) {
        var elementTop = jQuery?.(this).offset().top;
        var elementBottom = elementTop + jQuery(this).outerHeight();

        var viewportTop = jQuery?.(window).scrollTop();
        var viewportBottom = viewportTop + jQuery?.(window).height();

        return extra + elementBottom > viewportTop && elementTop < extra + viewportBottom;
    };
}

window.tmp = window.tmp || {};

tmp = window.tmp;

tmp.old = true;

tmp.images_url = "https://images.tmp.dk/images/";

tmp.array_remove_value = function (arr) {
    var what,
        a = arguments,
        L = a.length,
        ax;
    while (L > 1 && arr.length) {
        what = a[--L];
        while ((ax = arr.indexOf(what)) !== -1) {
            arr.splice(ax, 1);
        }
    }
    return arr;
};

tmp.array_filter_unique_values = function (array) {
    var a = array.concat();
    for (var i = 0; i < a.length; ++i) {
        for (var j = i + 1; j < a.length; ++j) {
            if (a[i] === a[j]) a.splice(j--, 1);
        }
    }

    return a;
};

tmp.getCountryByCode = (code) => {
    const arr = tmp_settings?.countries?.filter((item) => item.iso_2 === code);
    if (arr[0]) {
        return arr[0];
    }

    return null;
};

tmp.google = function () {};
tmp.google.maps = function () {};
/*if (typeof google?.maps?.Geocoder !== "undefined" && google?.maps?.Geocoder !== null) {
    tmp.google.maps.geo = new google.maps.Geocoder();
}*/

tmp.gtag = (...args) => {
    try {
        window.gtag(...args);
    } catch (ex) {
        console.log("tried to push ga(google analytics) event but failed.", args);
    }
};

tmp.fbq = (...args) => {
    try {
        fbq(...args);
    } catch (ex) {
        console.log("tried to push fbq(facebook pixel) event but failed.", args);
    }
};

/*tmp.key = function () {};
tmp.key.enter = false;
tmp.key.shift = false;
tmp.key.ctrl = false;

if (typeof window !== "undefined" && typeof jQuery !== "undefined") {
    jQuery?.(window).on("keydown", function (e) {
        if (e.keyCode === 13) {
            tmp.key.enter = true;
        }
        if (e.keyCode === 16) {
            tmp.key.shift = true;
        }
        if (e.keyCode === 17) {
            tmp.key.ctrl = true;
        }
    });

    jQuery?.(window).on("keyup", function (e) {
        if (e.keyCode === 13) {
            tmp.key.enter = false;
        }
        if (e.keyCode === 16) {
            tmp.key.shift = false;
        }
        if (e.keyCode === 17) {
            tmp.key.ctrl = false;
        }
    });
}*/

tmp.datatypes = function () {};

tmp.datatypes.types = {};

tmp.datatypes.base = function (obj) {
    return jQuery?.extend(
        {
            elements: {},
            init: function () {},
            initElements: function () {},
            initEvents: function () {},
            ready: function () {},
            getElementSettings: function () {
                const d = this;
                let settings = d.$el.data("settings");
                return tmp.utils.json.decode(settings);
            },
        },
        obj
    );
};

tmp.datatypes.add = function (datatype, obj) {
    tmp.datatypes.types[datatype] = obj;
};

tmp.datatypes.do = function () {
    jQuery?.each(tmp.datatypes.types, function (type, obj) {
        jQuery(".tmp-datatype-" + type).each(function () {
            const t = jQuery(this);
            const val = t.find(".tmp-datatype-value");
            const c_obj = _.clone(obj);
            c_obj.$el = t;
            c_obj.$val = val;
            c_obj.elements = {};
            c_obj.init();
            c_obj.initElements();
            c_obj.initEvents();
            c_obj.ready();
        });
    });
};

tmp.admin = function () {};

tmp.admin.tmp_selected_products = [];

tmp.loop_form_data = function (data) {
    let return_data = {};

    jQuery?.each(data, function (key, value) {
        if (typeof yourVariable === "object" && yourVariable !== null) {
            jQuery.extend(return_data, tmp.loop_form_data());
        }
        return_data[key];
    });

    return return_data;
};

tmp.get_products = function (args) {
    if (args == null) {
        args = {};
    }
    let post_data = {
        product_id: tmp_settings.current_product_id,
    };
    if (args.hasOwnProperty("post")) {
        post_data = jQuery?.extend(post_data, args.post);
    }
    let get_data = {
        "p-page": tmp.utils.url.get_param("p-page"),
        perpage: tmp.utils.url.get_param("perpage"),
    };

    if (
        tmp.utils.url.get_param("q") ? tmp.utils.url.get_param("q") : tmp.utils.url.get_param("s")
    ) {
        get_data.q = tmp.utils.url.get_param("q")
            ? tmp.utils.url.get_param("q")
            : tmp.utils.url.get_param("s");
    }

    if (tmp.utils.url.get_param("mark")) {
        get_data.mark = tmp.utils.url.get_param("mark");
    }

    if (tmp.utils.url.get_param("model")) {
        get_data.model = tmp.utils.url.get_param("model");
    }

    if (parseInt(tmp.utils.url.get_param("aargang"))) {
        get_data.aargang = parseInt(tmp.utils.url.get_param("aargang"));
    }

    if (parseInt(tmp.utils.url.get_param("kubik"))) {
        get_data.kubik = parseInt(tmp.utils.url.get_param("kubik"));
    }

    if (args.hasOwnProperty("get")) {
        get_data = jQuery?.extend(get_data, args.get);
    }

    let uri = "/wp-content/plugins/tmp/api/products.php";

    /*jQuery.each(get_data, function (key, value) {
        uri = tmp.utils.update_query_string_param(key, value, uri);
    });*/

    const data = { ...get_data, ...post_data };

    return axios
        .get(uri, {
            params: data,
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        })
        .then((response) => response.data);
};

tmp.build_form_data = function (formData, data, parentKey) {
    if (data && typeof data === "object" && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach((key) => {
            tmp.build_form_data(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
        });
    } else {
        const value = data == null ? "" : data;

        formData.append(parentKey, value);
    }
};

tmp.json_to_form_data = function (data) {
    const formData = new FormData();

    tmp.build_form_data(formData, data);

    return formData;
};

tmp.cart = function () {};

tmp.cart.count = function () {
    axios.get("/wp-content/plugins/tmp/api/cart/count.php").then((response) => {
        ///wp-json/tmp/v1/cart/count
        jQuery(".tmp-cart-button-icon-container").attr("data-count", response?.data?.data?.count);
    });
};

tmp.cart.reloadComponents = [];
tmp.cart.reloadComponentsData = null;

tmp.cart.load = function (count = true) {
    if (tmp.cart.reloadComponentsData) {
        tmp.cart.reloadComponentsData()?.then((response) => {
            if (!response.data) {
                return;
            }

            tmp.cart.reloadComponents.map((item) => {
                item({ ...response.data.data, lastUpdate: Date.now() });
            });
        });
    }

    if (count) {
        tmp.cart.count();
    }
};

tmp.cart.notice = function (message, options) {
    tmp.notice("<div class='tmp-notice-cart tmp-cart-button'>" + message + "</div>", options);
};

tmp.wp = function () {};

tmp.wp.page_id = function () {
    let page_body = jQuery("body.page");
    let id = 0;
    if (page_body) {
        let classAttr = page_body.attr("class");
        if (classAttr) {
            let classList = classAttr.split(/\s+/);
            jQuery.each(classList, function (index, item) {
                if (item.indexOf("page-id") >= 0) {
                    let item_arr = item.split("-");
                    id = item_arr[item_arr.length - 1];
                    return false;
                }
            });
        }
    }
    return id;
};

tmp.wp.ajax = function (action, data, callback) {
    data["action"] = action;
    jQuery
        .ajax({
            url: "/wp-admin/admin-ajax.php",
            method: "post",
            data: data,
        })
        .done(callback);
    //window.wp.ajax.post(action, data).always(callback);
};

tmp.wp.ajax.queue = [];

tmp.wp.ajax.queue_running = false;

tmp.wp.ajax.add_queue = function (action, data, callback) {
    if (!tmp.wp.ajax.queue_running) {
        tmp.wp.ajax.queue.push({
            action: action,
            data: data,
            callback: callback,
        });
    }
};

tmp.wp.ajax.run_queue_item = function () {
    if (tmp.wp.ajax.queue.length) {
        let item = tmp.wp.ajax.queue[0];
        tmp.wp.ajax(item.action, item.data, function (response) {
            item["callback"](response);
            tmp.wp.ajax.queue.splice(0, 1);
            tmp.wp.ajax.run_queue_item();
        });
    } else {
        tmp.wp.ajax.queue_running = false;
    }
};

tmp.wp.ajax.run_queue = function () {
    if (!tmp.wp.ajax.queue_running) {
        tmp.wp.ajax.queue_running = true;
        tmp.wp.ajax.run_queue_item();
    }
};

tmp.notice = function (content, options) {
    let settings = jQuery?.extend(
        {
            classes: [],
        },
        options
    );
    let classes = settings.classes.toString().replace(",", " ");
    let id = "tmp-notice-" + Date.now();
    jQuery?.(".tmp-notice-container").prepend(
        '<div><div id="' + id + '" class="tmp-notice ' + classes + '">' + content + "</div></div>"
    );
    setTimeout(function () {
        /*jQuery("#"+id).fadeOut(1000, function(){
            jQuery(this).remove();
        });*/
        jQuery?.("#" + id).addClass("tmp-notice-out");
        setTimeout(function () {
            jQuery?.("#" + id).remove();
        }, 1000);
    }, 4000);
};

tmp.loading = function (el, options) {
    let settings = jQuery?.extend(
        {
            icon_size: "fa-1x",
            classes: [],
            css: {},
            parent_css: {
                position: "relative",
            },
        },
        options
    );
    let id = new Date().getUTCMilliseconds();
    let id_string = "tmp-loading-container-" + id;
    let classes = settings.classes.toString().replace(",", " ");
    jQuery?.(el)
        .css(settings.parent_css)
        .append(
            "<div id='" +
                id_string +
                "' class='tmp-loading-container " +
                classes +
                "'><div class='tmp-loading'><i class='tmp-loading-icon fa fas " +
                settings.icon_size +
                " fa-cog fa-spin'></i></div></div>"
        );
    jQuery?.("#" + id_string).css(settings.css);
    return "#" + id_string;
};

tmp.loading_remove = function (id_string) {
    jQuery?.(id_string).parent().css({ position: "" });
    jQuery?.(id_string).remove();
};

tmp.body_loading = function () {
    jQuery?.("html").css({ overflow: "hidden" });
    el = tmp.loading("body", {
        icon_size: "fa-3x",
    });
    jQuery?.(el).css({
        position: "fixed",
        "z-index": 99998,
    });
    return el;
};

tmp.body_loading_remove = function (id_string) {
    jQuery?.("html").css({ overflow: "" });
    tmp.loading_remove(id_string);
};

tmp.corner_loading = function () {
    el = tmp.loading("body", {
        icon_size: "fa-3x",
        css: {
            position: "fixed",
            "z-index": 99998,
            color: "#000",
            left: "20px",
            bottom: "20px",
            top: "initial",
            right: "initial",
            "background-color": "initial",
        },
    });
    return el;
};

tmp.utils = function () {};

tmp.utils.json = function () {};

tmp.utils.json.decode = function (json) {
    let return_json = [];
    try {
        return_json = JSON.parse(json);
    } catch (e) {}

    return return_json;
};

tmp.utils.json.encode = function (json) {
    let return_json = "";
    try {
        return_json = JSON.stringify(json);
    } catch (e) {}

    return return_json;
};

tmp.utils.array_to_string = function (array) {
    let str = "";
    for (let i = 0; i < array.length; i++) {
        str += array[i] + ",";
    }
    return str.substring(0, str.length - 1);
};

tmp.utils.update_query_string_param = function (key, value, uri) {
    if (!uri) {
        uri = tmp.utils.url();
    }
    let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    let separator = uri.indexOf("?") !== -1 ? "&" : "?";
    if (uri.match(re)) {
        return uri.replace(re, "$1" + key + "=" + value + "$2");
    } else {
        return uri + separator + key + "=" + value;
    }
};

//url utils
tmp.utils.url = function () {
    //return new URL(window.location.href);
    return window.location.href;
};

tmp.utils.url.get_param = function (param, uri) {
    if (!uri) {
        uri = window.location.search.substring(1);
    } else {
        uri = uri.split("?");
        if (!uri[1]) {
            return "";
        }
        uri = uri[1];
    }
    //return tmp.utils.url().searchParams.get(param);
    let vars = uri.split("&");
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] == param) {
            return pair[1];
        }
    }
    return "";
};

tmp.utils.url.update_query_string_param = function (key, value, uri) {
    if (!uri) {
        uri = tmp.utils.url();
    }

    if (Array.isArray(key)) {
        jQuery?.each(key, (key1, value1) => {
            uri = tmp.utils.update_query_string_param(key1, value1, uri);
        });
    } else {
        uri = tmp.utils.update_query_string_param(key, value, uri);
    }

    return window.history.replaceState(null, document.Title, uri);
};

tmp.utils.url.push_update_query_string_param = function (key, value, uri) {
    if (!uri) {
        uri = tmp.utils.url();
    }

    if (typeof key === "object" && key !== null) {
        jQuery?.each(key, (key1, value1) => {
            uri = tmp.utils.update_query_string_param(key1, value1, uri);
        });
    } else {
        uri = tmp.utils.update_query_string_param(key, value, uri);
    }

    return window.history.pushState(null, document.Title, uri);
};

tmp.utils.url.remove_query_string_param = function (parameter, uri) {
    if (!uri) {
        uri = tmp.utils.url();
    }
    let urlparts = uri.split("?");
    if (urlparts.length >= 2) {
        let prefix = encodeURIComponent(parameter) + "=";
        let pars = urlparts[1].split(/[&;]/g);

        for (var i = pars.length; i-- > 0; ) {
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        return window.history.replaceState(
            null,
            document.Title,
            urlparts[0] + (pars.length > 0 ? "?" + pars.join("&") : "")
        );
    }
    return window.history.replaceState(null, document.Title, uri);
};

tmp.utils.url.push_remove_query_string_param = function (parameter, uri) {
    if (!uri) {
        uri = tmp.utils.url();
    }
    let urlparts = uri.split("?");
    if (urlparts.length >= 2) {
        let prefix = encodeURIComponent(parameter) + "=";
        let pars = urlparts[1].split(/[&;]/g);

        for (var i = pars.length; i-- > 0; ) {
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        return window.history.pushState(
            null,
            document.Title,
            urlparts[0] + (pars.length > 0 ? "?" + pars.join("&") : "")
        );
    }
    return window.history.pushState(null, document.Title, uri);
};
//end - url utils

//tracking
(function () {
    //tmp.ga("require", "ecommerce");
    jQuery?.(() => {
        if (jQuery("body").hasClass("tmp-product-page")) {
            tmp.fbq("track", "ViewContent", {
                content_name: tmp_settings.current_product.title,
                content_type: "product",
                content_ids: [tmp_settings.current_product.sku],
            });
            tmp.gtag("event", "view_item", {
                currency: tmp_settings.currency,
                value: tmp_settings.current_product.price_info.price,
                items: [
                    {
                        item_id: tmp_settings.current_product.sku,
                        item_name: tmp_settings.current_product.title,
                        price: tmp_settings.current_product.price_info.price,
                        quantity: 1,
                    },
                ],
            });
        }
    });

    jQuery?.(document).on("submit_success", (e, formId) => {
        //Push test ride event
        if (e.target.name === "testride") {
            //tmp.fbq("track", "CompleteRegistration");
            /*tmp.gtag("event", "submit", {
                event_category: "TestRide",
                event_label: "Clicked the submit button on a Newsletter form",
            });*/
        }

        //Push newsletter event
        if (e.target.name === "newsletter") {
            //moved to server side tracking
            //tmp.fbq("track", "Lead");
            /*tmp.gtag("event", "submit", {
                event_category: "Newsletter",
                event_label: "Signed up for the newsletter",
            });*/
        }
    });

    function getTextFromNodes(node, accumulator) {
        if (node.nodeType === 3)
            // 3 == text node
            accumulator.push(node.nodeValue.trim());
        else {
            for (let child of node.childNodes) {
                getTextFromNodes(child, accumulator);
            }
        }
    }

    //Push contact event
    jQuery?.("body").on("click", '*[id^="track-"]', (e) => {
        let trackId = e.currentTarget.id;
        trackId = trackId.substring(6);
        trackId = trackId.trim();

        const texts = [];
        getTextFromNodes(e.currentTarget, texts);

        tmp.gtag("event", "click", {
            id: trackId,
            subject: e.currentTarget.dataset.trackSubject,
            element_text: texts.filter((text) => text).join(" - "),
        });
    });

    jQuery?.("body").on("click", 'a[href^="tel:"]', (e) => {
        let trackPhone = decodeURI(e.currentTarget.href);
        trackPhone = trackPhone.substring(5);
        trackPhone = trackPhone.trim();

        tmp.gtag("event", "phone_click", {
            phone: trackPhone,
        });

        //moved to server side tracking
        tmp.fbq("track", "PhoneClick", { phone: trackPhone });

        //ga universal - is outdated
        /*tmp.gtag("event", "click", {
            event_category: "Contact",
            event_label: "tel: link, The number is: " + trackPhone,
        });*/
    });

    jQuery?.("body").on("click", 'a[href^="mailto:"]', (e) => {
        let trackEmail = decodeURI(e.currentTarget.href);
        trackEmail = trackEmail.substring(7);
        trackEmail = trackEmail.trim();

        tmp.gtag("event", "email_click", {
            email: trackEmail,
        });

        //moved to server side tracking
        tmp.fbq("track", "EmailClick", { email: trackEmail });

        //ga universal - is outdated
        /*tmp.gtag("event", "click", {
            event_category: "Contact",
            event_label: "mailto: link, The mail is: " + trackEmail,
        });*/
    });
})();
//end - tracking

tmp.modal = function () {};

tmp.modal.selectors = {
    container: ".tmp-modal-container",
    modal: ".tmp-modal",
    content: ".tmp-modal-content",
};

tmp.modal.open = function (el) {
    const modal = jQuery(".tmp-modal-container");
    modal.find(".tmp-modal-content").html(jQuery(el).html());
    modal.css({
        display: "block",
    });
    jQuery?.(window).trigger("tmp/modal/open");
};

tmp.modal.close = function () {
    const modal = jQuery(".tmp-modal-container");
    modal.find(".tmp-modal-content").html("");
    modal.css({
        display: "none",
    });
    jQuery?.(window).trigger("tmp/modal/close");
};

jQuery?.(function () {
    jQuery?.("body" + ' *[data-toggle="modal"][data-target]').on("click", function (e) {
        e.stopPropagation();
        const t = jQuery?.(this);
        tmp.modal.open(t.attr("data-target"));
    });
    jQuery?.("body").on("click", ".tmp-modal-close", function (e) {
        const t = jQuery?.(this);
        tmp.modal.close();
    });

    if (tmp.old) {
        const id = tmp.utils.url.get_param("modal");
        if (id) {
            tmp.modal.open("#" + id);
        }

        tmp.cart.count();
    }
});
